<template>
  <div>
    <v-tabs
    v-model="tab"
    flat
    background-color="primary"
    dark
    height="40"
    grow grow @change="refreshData()">
    <v-tab v-for="(tabItem, n) in tabitems" :key="n" :href="`#tab-${n}`">
      {{ tabItem + ' (' + totalStats[n] + ')' }}
    </v-tab>
  </v-tabs>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 mx-auto>
        <v-tabs-items v-model="tab" @change="refreshData()">
          <v-tab-item :key="0" value="tab-0">
            <v-layout row wrap>
              <v-flex xs12 class="pa-0">
                <v-card>
                  <v-card-text class="pa-0">
                    <v-card-actions class="grey lighten-4 caption">
                      <v-layout row wrap>
                        <v-flex xs4>
                          <v-combobox
                          class="mt-1"
                          v-model="curComm"
                          label="Community"
                          :items="commList"
                          item-text="comm_name"
                          item-value="comm_id"
                          placeholder="Choose"
                          clearable
                          @input="loadStaffAndVendorBasedonComm(curComm)"
                          hide-details
                          ></v-combobox>
                        </v-flex>
                        <v-flex xs4>
                          <v-select
                          class="mt-1 pa-0"
                          v-model="chosenVendor"
                          label="Vendor filter"
                          :items="staffVendors"
                          item-value="vendor_id"
                          item-text="vendor_name"
                          clearable
                          chips
                          multiple
                          hide-details
                          @input="loadStaffs"
                          ></v-select>
                        </v-flex>
                        <v-flex xs4>
                          <v-download-as
                          class="pa-2"
                          :headers="staffHeadSm"
                          :items="staff"
                          title="Staff List"
                          ></v-download-as>
                        </v-flex>
                        <v-flex xs7>
                          <v-text-field
                          append-icon="mdi-account-search"
                          v-model="search"
                          class="pa-0 mb-2 mt-3"
                          placeholder="Search name, role, etc..."
                          clearable
                          hide-details
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-switch
                          class="ml-5"
                          v-model="showAll"
                          label="Show past staffs as well"
                          @change="loadStaffs"
                          hide-details
                          ></v-switch>
                        </v-flex>
                        <v-flex xs2 class="text-right">
                          <v-btn small @click.stop="showQRCode(true)" class="mt-3"><v-icon class="pr-2">mdi-qrcode</v-icon>QR Code</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-actions>
                    <v-data-table v-if="staff.length > 0"
                      :headers="$vuetify.breakpoint.smAndUp?staffHeadSm:staffHead"
                      :items="staff"
                      hide-default-footer
                      :search="search"
                      disable-pagination
                      :mobile-breakpoint="0"
                      >
                      <template slot="item" slot-scope="props">
                        <tr :class="props.item.type === 'VS' ? (props.item.undeployed_on ? 'grey--text subtitle-1' : 'tertiary--text subtitle-1') : (props.item.undeployed_on ? 'grey--text subtitle-1' : '')">
                          <td>{{ props.item.staff_role }}</td>
                          <td>{{ props.item.vendor_emp_id?props.item.vendor_emp_id:'-' }}</td>
                          <td>{{ props.item.staff_name }}</td>
                          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.staff_mobile }}</td>
                          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.shift_abbr }}</td>
                          <td v-if="$vuetify.breakpoint.smAndUp">
                            <v-icon color="green" v-if="props.item.is_billable === 1">mdi-check</v-icon>
                            <v-icon color="red" v-else>mdi-close</v-icon>
                          </td>
                          <td v-if="$vuetify.breakpoint.smAndUp && props.item.is_smart_attend" class="text-center"><v-icon :color="props.item.is_ms_face_synched ? 'success' : 'warning'">mdi-check</v-icon><v-icon :color="props.item.is_fc_dev_synched ? 'success' : 'warning'">mdi-check</v-icon></td>
                          <td v-else-if="$vuetify.breakpoint.smAndUp" class="text-center"><v-icon color="error">mdi-close</v-icon></td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-tab-item>
          <!--shift -->
          <v-tab-item :key="1" value="tab-1">
            <v-card flat v-if="lAction === 'view'">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-combobox
                    v-model="curComm"
                    label="Community"
                    :items="commList"
                    item-text="comm_name"
                    item-value="comm_id"
                    placeholder="Choose"
                    filled
                    clearable
                    @input="curComm ? loadShifts(curComm) : ''"
                    ></v-combobox>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="px-0 py-3" v-if="curComm && curComm.comm_id">
                <v-data-table
                :headers="$vuetify.breakpoint.smAndUp?shiftHeadSm:shiftHead"
                :items="shifts"
                hide-default-footer
                class="elevation-2"
                sort-by="shift_abbr"
                :mobile-breakpoint="0"
                >
                <template slot="item" slot-scope="props">
                  <tr @click="prepareUpdateShift(props.item)">
                    <td>{{ props.item.shift_abbr }}</td>
                    <td>{{ props.item.start_time }}</td>
                    <td>{{ props.item.end_time }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.shift_hours }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.break_start }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.break_end }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>

        </v-tab-item>
        <!-- Roles -->
        <v-tab-item :key="2" value="tab-2">
          <v-card flat v-if="lAction === 'view'">
            <v-card-title class="px-0 py-2">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-combobox
                  v-model="curComm"
                  label="Community"
                  :items="commList"
                  item-text="comm_name"
                  item-value="comm_id"
                  placeholder="Choose"
                  @input="curComm ? loadRoles(curComm) : ''"
                  filled
                  clearable
                  ></v-combobox>
                </v-flex>
                <v-flex xs6 v-if="curComm && curComm.comm_id">
                  <v-text-field
                  class="pt-0"
                  append-icon="mdi-account-search"
                  :placeholder="$vuetify.breakpoint.smAndUp?'Search by Name, Description, etc.':'Search'"
                  hide-details
                  v-model="search"
                  outlined
                  clearable
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 v-if="curComm && curComm.comm_id">
                  <v-download-as
                  :headers="roleHead"
                  :items="roles"
                  title="Roles list"
                  ></v-download-as>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="px-0 py-3" v-if="curComm && curComm.comm_id">
              <v-data-table
              :headers="roleHead"
              :items="roles"
              hide-default-footer
              class="elevation-2"
              :search="search"
              disable-pagination
              sort-by="role_cat"
              :mobile-breakpoint="0"
              >
              <template slot="item" slot-scope="props">
                <tr @click="prepareUpdate(props.item)">
                  <td>{{ props.item.staff_role }}</td>
                  <td>{{ props.item.role_cat }}</td>
                  <td>{{ props.item.short_form }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>

      <v-btn v-if="tab === 'tab-1' || tab === 'tab-2'"
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed
      color="accent black--text"
      @click.native="tab === 'tab-1' ? prepareCreateShift() : prepareCreateRole()">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

  </v-tabs-items>

  <!-- create, update and delete shift -->
  <v-container v-if="lAction === 'create-shift' || lAction === 'update-shift'" class="pa-0" fluid full-height>
    <v-layout row wrap>
      <v-flex xs12>
        <v-form ref="sForm" @submit.prevent="saveChangesShift(lAction)">
          <v-card flat>
            <v-flex xs12 sm8 mx-auto>
              <v-card-title class="title pb-0">
                {{lAction === 'create-shift' ? 'Create' : 'Update' }} Shift
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                    label="Shift Abbreviation"
                    v-model="lShift.shift_abbr"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="15"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-dialog
                    ref="shiftStart"
                    persistent
                    v-model="dlgShiftStart"
                    max-width="290px"
                    :return-value.sync="lShift.start_time"
                    >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                      slot="activator"
                      label="Starts at"
                      v-model="lShift.start_time"
                      append-icon="mdi-clock"
                      clearable
                      readonly
                      v-on="on"
                      hide-details
                      :rules="[rules.required]"
                      ></v-text-field>
                    </template>
                    <v-time-picker v-model="lShift.start_time"
                    ampm-in-title>
                    <div class="flex-grow-1"></div>
                    <v-btn  @click="dlgShiftStart = false">Cancel</v-btn>
                    <v-btn  color="accent" @click="$refs.shiftStart.save(lShift.start_time)">OK</v-btn>
                  </v-time-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs6>
                <v-dialog
                ref="shiftEnd"
                persistent
                v-model="dlgShiftEnd"
                max-width="290px"
                :return-value.sync="lShift.end_time"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                  slot="activator"
                  label="Ends at"
                  v-model="lShift.end_time"
                  append-icon="mdi-clock"
                  clearable
                  readonly
                  v-on="on"
                  hide-details
                  :rules="[rules.required]"
                  ></v-text-field>
                </template>
                <v-time-picker v-model="lShift.end_time" ampm-in-title>
                  <div class="flex-grow-1"></div>
                  <v-btn  @click="dlgShiftEnd = false">Cancel</v-btn>
                  <v-btn  color="accent" @click="$refs.shiftEnd.save(lShift.end_time)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-text-field
              label="Shift Hours"
              v-model="lShift.shift_hours"
              :rules="[rules.required]"
              hide-details
              maxlength="5"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <div class="subheader mt-3 primary--text">
                Additional information (optional)
              </div>
            </v-flex>
            <v-flex xs6>
              <v-dialog
              ref="breakStart"
              persistent
              v-model="dlgBreakStart"
              max-width="290px"
              :return-value.sync="lShift.break_start"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                slot="activator"
                label="Break from"
                v-model="lShift.break_start"
                append-icon="mdi-clock"
                clearable
                readonly
                v-on="on"
                hide-details
                ></v-text-field>
              </template>
              <v-time-picker v-model="lShift.break_start" ampm-in-title>
                <div class="flex-grow-1"></div>
                <v-btn  @click="dlgBreakStart = false">Cancel</v-btn>
                <v-btn  color="accent" @click="$refs.breakStart.save(lShift.break_start)">OK</v-btn>
              </v-time-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog
            ref="breakEnd"
            persistent
            v-model="dlgBreakEnd"
            max-width="290px"
            :return-value.sync="lShift.break_end"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator"
              label="Break till"
              v-model="lShift.break_end"
              append-icon="mdi-clock"
              clearable
              readonly
              v-on="on"
              hide-details
              ></v-text-field>
            </template>
            <v-time-picker v-model="lShift.break_end" ampm-in-title>
              <div class="flex-grow-1"></div>
              <v-btn  @click="dlgBreakEnd = false">Cancel</v-btn>
              <v-btn  color="accent" @click="$refs.breakEnd.save(lShift.break_end)">OK</v-btn>
            </v-time-picker>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-btn v-if="lAction === 'update-shift'"  @click.stop="deleteShift">Delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn  @click.stop="cancelChanges">Cancel</v-btn>
      <v-btn  type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
    </v-card-actions>
  </v-flex>
</v-card>
</v-form>
</v-flex>
</v-layout>
</v-container>

<!-- create / update / delete roles -->
<v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
  <v-layout row wrap>
    <v-flex xs12>
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
        <v-card flat>
          <v-flex xs12 sm9 md7 mx-auto>
            <v-card-title class="px-0 py-2">
              {{handy.startWithUpper(lAction) + ' Role'}}
            </v-card-title>
            <v-card-text class="px-0 py-3">
              <v-flex xs12 class="pa-2">
                <v-select
                label="Category"
                :items="['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS']"
                v-model="lRole.role_cat"
                :rules="[rules.required]"
                hide-details
                maxlength="20"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="pa-2">
                <v-text-field
                v-model.trim="lRole.staff_role"
                label="Role Name"
                :rules="[rules.required]"
                hide-details
                maxlength="25"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-2">
                <v-text-field
                label="Short Form of Role Name"
                v-model="lRole.short_form"
                :rules="[rules.required]"
                maxlength="8"
                hide-details
                ></v-text-field>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="lAction === 'update'" @click.stop="deleteRole">Delete</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click.stop="cancelChanges">Close</v-btn>
              <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<v-dialog v-model="dlgQRCode" max-width="800px" scrollable>
  <v-card flat>
    <v-card-text class="text-xs-center" ref="qrcode">
      <table>
        <tr v-for="(staffRow, i) in qrStaffList" :key="i">
          <td v-for="(staff, j) in staffRow" :key="j" style="padding:25px">
            <qrcode-vue v-if="staff.is_smart_attend" :value="staff.person_id + ''" size="135" level="H" render-as="svg"></qrcode-vue>
            <div style="text-align:center; font-size:125%" v-else>X</div>
            <div style="font-size:85%; padding-top:10px; text-align:center;">
              {{staff.staff_name.substring(0,20)}}
            </div>
          </td>
        </tr>
      </table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="dlgQRCode=false">close</v-btn>
      <v-btn text @click="printQRCode"><v-icon class="pr-2">mdi-printer</v-icon>Print</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-flex>
</v-layout>
</v-container>
</div>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'
import QrcodeVue from 'qrcode.vue'

export default {
  components:
  {
    'v-download-as': VDownloadAs,
    QrcodeVue
  },
  data () {
    return {
      //common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      lAction: 'view',
      // component specific
      tab: 'tab-0',
      totalStats: {},
      tabitems: ['staff', 'shift', 'role'],
      search: '',
      staff: [],
      showAll: false,
      chosenVendor: [],
      staffVendors: [],
      staffHead: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Emp ID', value: 'vendor_emp_id' },
        { text: 'Name', value: 'staff_name' }
      ],
      staffHeadSm: [
        { text: 'Role', value: 'staff_role' },
        { text: 'Emp ID', value: 'vendor_emp_id' },
        { text: 'Name', value: 'staff_name' },
        { text: 'Mobile', value: 'staff_mobile' },
        { text: 'Shift', value: 'shift_abbr' },
        { text: 'Billable?', value: 'is_billable' },
        { text: 'Smart Attendance?', value: 'is_smart_attend', align: 'center' }
      ],
      commList: [],
      curComm: '',
      dlgQRCode: false,
      qrStaffList: [],
      lStaff: '',
      // shifts
      shifts: [],
      shiftHead: [
        { text: 'Shift', value: 'shift_abbr' },
        { text: 'Starts At', value: 'start_time' },
        { text: 'Ends At', value: 'end_time' }
      ],
      shiftHeadSm: [
        { text: 'Shift', value: 'shift_abbr' },
        { text: 'Starts At', value: 'start_time' },
        { text: 'Ends At', value: 'end_time' },
        { text: 'Shift Hours', value: 'shift_hours' },
        { text: 'Break From', value: 'break_start' },
        { text: 'Break Till', value: 'break_end' }
      ],
      lShift: '',
      dlgShiftStart: false,
      dlgShiftEnd: false,
      dlgBreakStart: false,
      dlgBreakEnd: false,
      // roles
      lRole: {},
      roles: [],
      roleHead: [
        { text: 'Role Name', value: 'staff_role' },
        { text: 'Category', value: 'role_cat' },
        { text: 'Short Form', value: 'short_form' }
      ]
    }
  },
  created () {
    this.loadComm()
    for (var i = 0; i < this.tabitems.length; i++) {
      this.totalStats[i] = 0
    }
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    refreshData () {
      if (this.tab === 'tab-0') {
        this.loadStaffs()
      } else if (this.tab === 'tab-1') {
        this.loadShifts()
      } else {
        this.loadRoles()
      }
    },
    loadStaffAndVendorBasedonComm (curCommunity) {
      if (curCommunity) {
        this.loadStaffVendor()
        this.loadStaffs()
      } else {
        this.staff = []
        this.totalStats[0] = this.staff.length
      }
    },
    loadStaffs () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id,
          show_all: this.showAll,
          vendor_list: this.chosenVendor
        }
      }
      // list of staffs
      this.axios.get(config.SMARTILITY_API_URL + '/getStaffByCommId/', qry)
      .then(response => {
        this.staff = response.data
        this.totalStats[0] = this.staff.length
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.staff = []
      })
    },
    loadStaffVendor () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      this.staffVendors = []
      this.axios.get(config.SMARTILITY_API_URL + '/getVendorWithStaffByCommId/', qry)
      .then(response => {
        this.staffVendors = response.data
      })
      .catch(err => {
        this.msg(err.response.data, true)
      })
    },
    loadComm () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/' , qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    showQRCode (all = false) {
      this.qrStaffList = []
      this.qrStaffList[0] = []
      if (all) {
        // create matrix 4 qr code in a row
        let idx = 0
        let j = 0
        for (let i = 1; i <= this.staff.length; i++) {
          this.qrStaffList[idx][j++] = this.staff[i - 1]
          if (i % 4 === 0) {
            ++idx
            this.qrStaffList[idx] = []
            j = 0
          }
        }
      } else {
        this.qrStaffList[0][0] = this.lStaff
      }
      this.dlgQRCode = true
    },
    printQRCode () {
      // print dialog
      var divContents = this.$refs.qrcode.innerHTML
      var a = window.open('', '', 'height:50; width:50')
      a.document.write('<html>')
      a.document.write('<head><title>QR Code - ' + this.curComm.comm_name + ' - ' + (this.qrStaffList[0].length > 1 ? 'All staffs' : this.lStaff.staff_name) + '</title></head>')
      a.document.write('<body>')
      a.document.write(divContents)
      a.document.write('</body></html>')
      a.document.close()
      a.print()
    },
    // shift
    loadShifts () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getShiftsByCommId/', qry)
      .then(response => {
        this.shifts = response.data
        this.totalStats[1] = this.shifts.length
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.shifts = []
      })
    },
    prepareCreateShift () {
      if (!this.curComm) {
        this.msg('Please choose a community to proceed', 2)
      } else {
        this.lShift = {
          comm_id: this.curComm.comm_id,
          shift_abbr: '',
          shift_hours: '',
          start_time: '',
          end_time: ''
        }
        this.lAction = 'create-shift'
      }
    },
    prepareUpdateShift (curShift) {
      this.lShift = Object.assign({}, curShift)
      this.lAction = 'update-shift'
    },
    saveChangesShift (action) {
      // validate and save Changes
      if (action === 'create-shift' || action === 'update-shift') {
        if (!this.$refs.sForm.validate()) {
          return
        }
      }
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/shift/' + action, this.lShift)
      .then(response => {
        this.loadShifts()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, true)
        this.beingSaved = false
      })
    },
    deleteShift () {
      // confirm
      if (confirm('Sure, you want to delete the shift "' + this.lShift.shift_abbr + '"?')) {
        // delete
        this.saveChangesShift('delete-shift')
      }
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    // Roles
    prepareCreateRole () {
      if (!this.curComm) {
        this.msg('Please choose a community to proceed', 2)
      } else {
        this.lRole = {
          comm_id: this.curComm.comm_id,
          staff_role: ''
        }
        this.lAction = 'create'
      }
    },
    prepareUpdate(curRole) {
      this.lRole = Object.assign({}, curRole) // keep the original object safely before changes
      this.lAction = 'update'
    },
    saveChanges (curAction) {
      if (curAction === 'delete') {
        if (!confirm('Sure, you want to delete the role "' + this.lRole.staff_role + '"?')) {
          return
        }
      } else if (!this.$refs.lForm.validate()) {
        return
      }
      // proceed with changes
      this.beingSaved = true
      this.axios.post(config.SMARTILITY_API_URL + '/role/' + (curAction + '-role'), this.lRole)
      .then(response => {
        this.loadRoles()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.beingSaved = false
      })
    },
    deleteRole () {
      this.saveChanges('delete')
    },
    loadRoles () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      this.axios.get(config.API_URL + '/getStaffRolesByCommId/', qry)
      .then(response => {
        this.roles = response.data
        this.totalStats[2] = this.roles.length
      })
      .catch(err => {
        this.msg(err.response.data)
        this.roles = []
      })
    }
  }
}
</script>
